import HamburgerMenuClose from "@assets/icons/hamburgerMenuClose"
import QuestionMarkIcon from "@assets/icons/questionMark"
import ContactIcon from "@assets/icons/contact"
import SideBarItem from "@components/Common/SideBarItem"
import { useNavigate, useSearchParams } from "react-router-dom"
import SignInAndSignOutButton from "@components/Common/SignInAndSignOutButton"
import styles from "./MobileSideBar.module.css"
import { useSelector } from "react-redux"
const MobileSideBar = ({ setShowMobileSideBar }) => {

  const navigate = useNavigate()

  const menuCloseIconClickHandler = () => {
    setShowMobileSideBar(false)
  }
  const { ownDetails } = useSelector((state) => state.profile)
  const { firstName, email } = ownDetails?.details || {}

  return (
    <div className={styles.mobileSideBarSection}>
      <div className={styles.sideBarItems}>
        <div
          className={styles.menuCloseIcon}
          onClick={menuCloseIconClickHandler}
        >
          <HamburgerMenuClose />
        </div>
        <SideBarItem
          linkClassName={styles.sideBarItem}
          showText={true}
          route="/dashboard"
          linkActiveClassName={styles.linkActive}
        />

        <SideBarItem
          linkClassName={styles.sideBarItem}
          showText={true}
          route="/manage-patient-vision"
          linkActiveClassName={styles.linkActive}
        />

        <SideBarItem
          linkClassName={styles.sideBarItem}
          showText={true}
          route="/manage-appointment"
          linkActiveClassName={styles.linkActive}
        />

        <SideBarItem
          linkClassName={styles.sideBarItem}
          showText={true}
          route="/other-apps"
          linkActiveClassName={styles.linkActive}
        />
        <SideBarItem
          linkClassName={styles.sideBarItem}
          showText={true}
          route="/my-account"
          linkActiveClassName={styles.linkActive}
        />
      </div>

      <div className={styles.mobileSideBarFooter}>
        <div className={styles.moreLinks}>
          <div className={styles.report} onClick={() => navigate("/report")} style={{ cursor: "pointer" }}>
            <QuestionMarkIcon />
            REPORT
          </div>
          <div className={styles.contact} onClick={() => navigate("/contact")} style={{ cursor: "pointer" }}>
            <ContactIcon />
            CONTACT
          </div>
        </div>
        <div className={styles.loginAndUserDetails}>
          <div className={styles.userInformation}>
            <div className={styles.userName}>Dr {firstName}</div>
            <div className={styles.email}>{email}</div>
          </div>

          <SignInAndSignOutButton
            signOutClassName={styles.signoutButton}
            signInClassName={styles.signoutButton + " " + styles.signInLink}
          />
        </div>
      </div>
    </div>
  )
}

export default MobileSideBar
